export function authHeader() {
    // return authorization header with jwt token
    let state;
    try {
        state = JSON.parse(localStorage.getItem('state'));
    } catch (e) {
        state = null;
    }

    if (state && state.auth && state.auth.token) {
        return { 'Authorization': 'Bearer ' + state.auth.token , 'Content-Type': 'application/json'};
    } else {
        return {};
    }
}